<template>
  <div>
    <h1 class="mb-8 font-bold text-3xl">
      <inertia-link class="text-indigo-400 hover:text-indigo-600" :href="route('reportemaquinaridiarios')">Diarios:</inertia-link>
      <span class="text-indigo-400 font-medium">/</span>
      {{ form.numero_comprobante }}
    </h1>
  
    <div class="bg-white rounded-md shadow overflow-hidden max-w-3xl">
      <form @submit.prevent="update">
        <div class="p-8 -mr-6 -mb-8 flex flex-wrap">
           <label class="pr-6 pb-8">Fecha:</label>
        <Datepicker  v-model="form.fecha" :error="form.errors.fecha" class="pr-6 pb-8 w-full lg:w-6/6" format="YYYY-MM-DD H:i:s" required/>
        
        <div class="container pb-8 pr-6 w-full lg:w-2/6">
            <label class="form-label" >Maquinaria:</label>
            <v-select v-model="form.maquinaria_id" :options="maquinarias" value="id" label="placas"></v-select>
            </div>
       
            <div class="container pb-8 pr-6 w-full lg:w-2/6">
            <label class="form-label" >Proyecto:</label>
            <v-select v-model="form.proyecto" :options="proyectos" value="id" label="nombre"></v-select>
            </div>
            <div class="container pb-8 pr-6 w-full lg:w-2/6">
            <label class="form-label" >Operador:</label>
            <v-select v-model="form.operador" :options="conductores" value="id" label="nombres"></v-select>
            </div>
          <text-input v-model="form.numero_comprobante" :error="form.errors.numero_comprobante" class="pr-6 pb-8 w-full lg:w-1/5" label="Nº Comprob." required/>
          <text-input v-model="form.hora_inicio" :error="form.errors.hora_inicio" class="pr-6 pb-8 w-full lg:w-1/5" label="Hora Inicio" required/>
          <text-input v-model="form.hora_fin" :error="form.errors.hora_fin" class="pr-6 pb-8 w-full lg:w-1/5" label="Hora Fin" required/>
          <select-input v-model="form.feriado" :error="form.errors.feriado" class="pr-6 pb-8 w-full lg:w-1/5" label="Hora Doble">
            <option>SI</option>
            <option>NO</option>
          </select-input>
          
          <text-input v-model="form.odometro_actual" :error="form.errors.odometro_actual" class="pr-6 pb-8 w-full lg:w-1/5" label="Odometro" required/>
          <text-input v-model="form.observacion" :error="form.errors.observacion" class="pr-6 pb-8 w-full lg:w-1/1" label="Observación" />
         <br><br><br><br><br>
          </div>
        <div class="px-8 py-4 bg-gray-50 border-t border-gray-100 flex items-center">
          <button class="text-red-600 hover:underline" tabindex="-1" type="button" @click="destroy">Borrar Despacho</button>
          <loading-button :loading="form.processing" class="btn-indigo ml-auto" type="submit">Actualizar Despacho</loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import TrashedMessage from '@/Shared/TrashedMessage'
import Datepicker from 'vuejs-datetimepicker'

export default {
  metaInfo() {
    return {
      title: `${this.form.numero_comprobante}`,
    }
  },
  components: {
    LoadingButton,
    SelectInput,
    TextInput,
    TrashedMessage,
    Datepicker,
    vSelect,
    SelectInput,
  },
  layout: Layout,
  props: {
    diario: Object,
    maquinarias: Array,
    proyectos: Array,
    conductores: Array,
  },
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        maquinaria_id: this.diario.id,
        fecha: this.diario.fecha,
        proyecto: this.diario.proyecto,
        operador: this.diario.operador,
        numero_comprobante: this.diario.numero_comprobante,
        hora_fin: this.diario.hora_fin,
        hora_inicio: this.diario.hora_inicio,
        odometro_actual: this.diario.odometro_actual,
        observacion: this.diario.observacion,
        feriado: 'NO',

      }),
    }
  },
  methods: {
    update() {
      this.form.put(this.route('reportemaquinaridiarios.update', this.diario.id))
    },
    destroy() {
      if (confirm('Estas Seguro de Eliminar?')) {
        this.$inertia.delete(this.route('reportemaquinaridiarios.destroy', this.diario.id))
      }
    },
    restore() {
      if (confirm('Piensalo Bien!?')) {
        this.$inertia.put(this.route('despachos.restore', this.despacho.id))
      }
    },
  },
}
</script>
